module.exports = {
  "zones": {
    "Indian/Cocos": ["z", {
      "wallclock": -2208988800000,
      "format": "+0630",
      "abbrev": "+0630",
      "offset": 23400000,
      "posix": -2209012060000,
      "save": 0
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": 23260000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {}
};